import styles from "./linkDomainScreenBackground.module.scss";

/** Домен link: #4a4574 → #6d5f94 (светлее hub, тот же низ) */
export function LinkDomainScreenBackground() {
  return <div className={styles.root} aria-hidden />;
}
